module.exports = __webpack_public_path__ + "assets/img/2-6.8ca196b4.png";